import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
const baseQueryWithHeader = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BACKEND_URL,
  credentials: 'include',
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('userAuthToken');
    // If we have a token set in state
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQueryWithHeader(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    localStorage.removeItem('userAuthToken');
    localStorage.removeItem('loggedInUserUUID');
    const currentPath = window.location.pathname;

    if (!currentPath.includes('/login')) {
      window.location.reload();
    }
  }
  return result;
};

export { baseQuery };
